import { useState } from "react";

import { payOrder } from "./money";
import { btn, C, FONT } from "./publicShared";

// Voluntary dakshina for the free Gita. Never a wall, never a popup — a quiet
// card after the day's verse. Small auspicious amounts, UPI first.

const T = {
  en: { title: "Offer dakshina", body: "The daily Gita, its meaning and the 21-day journey stay free for everyone. If they help you, a small offering keeps them going.", thanks: "Thank you 🙏 Your dakshina is received.", login: "Sign in to offer dakshina." },
  hi: { title: "दक्षिणा अर्पित करें", body: "रोज़ की गीता, उसका अर्थ और 21 दिन की यात्रा सबके लिए मुफ़्त रहेंगे। अगर ये आपकी मदद करते हैं, तो छोटी सी दक्षिणा इन्हें चलाए रखती है।", thanks: "धन्यवाद 🙏 आपकी दक्षिणा मिल गई।", login: "दक्षिणा देने के लिए साइन इन करें।" },
  te: { title: "దక్షిణ సమర్పించండి", body: "రోజువారీ గీత, దాని అర్థం, 21 రోజుల ప్రయాణం అందరికీ ఉచితంగానే ఉంటాయి. ఇవి మీకు సహాయపడితే, చిన్న దక్షిణ వీటిని కొనసాగిస్తుంది.", thanks: "ధన్యవాదాలు 🙏 మీ దక్షిణ అందింది.", login: "దక్షిణ ఇవ్వడానికి సైన్ ఇన్ చేయండి." },
};

export default function DakshinaCard({ user, lang = "en" }) {
  const t = T[lang] || T.en;
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(null);
  const [err, setErr] = useState("");

  const give = async (amt) => {
    if (!user?.id) return setErr(t.login);
    setErr(""); setBusy(amt);
    try {
      const id = await payOrder({ user, kind: `dakshina_${amt}`, inputs: {}, description: `Dakshina ₹${amt}` });
      if (id) setDone(true);
    } catch (e) { setErr(e.message); }
    setBusy(null);
  };

  return (
    <div style={{ background: C.warm, border: `1.5px solid ${C.border}`, borderRadius: 16, padding: 20, margin: "20px auto", maxWidth: 600, fontFamily: FONT, color: C.text }}>
      <h3 style={{ fontSize: 21, margin: "0 0 8px" }}>🪔 {t.title}</h3>
      {done ? <p style={{ fontSize: 18, margin: 0 }}>{t.thanks}</p> : (
        <>
          <p style={{ fontSize: 17, lineHeight: 1.55, margin: "0 0 14px", color: C.dim }}>{t.body}</p>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {[11, 21, 51, 101].map((a) => (
              <button key={a} onClick={() => give(a)} disabled={!!busy}
                style={{ ...btn(C.card, C.accentDark), width: "auto", flex: "1 1 80px", border: `1.5px solid ${C.accent}`, opacity: busy && busy !== a ? 0.6 : 1 }}>
                ₹{a}
              </button>
            ))}
          </div>
        </>
      )}
      {err && <p style={{ fontSize: 16, color: "#B42318", margin: "10px 0 0" }}>{err}</p>}
    </div>
  );
}
